// AboutUsPage.js
import React from 'react';

const SupportUs = () => {
  return (
    <div>
       <div className="bg-[radial-gradient(ellipse_at_top_left,_var(--tw-gradient-stops))] from-black via-violet-800 to-amber-600 h-screen ">
        PEE
       </div>
  
    </div>
  );
};

export default SupportUs;
